module.exports = __webpack_public_path__ + "img/filter-icon-mobile.d172a818.svg";